import { CarouselItem, LoadingSpinner } from '@rabbit/elements/shared-components';
import Carousels from 'libs/elements/shared-components/src/lib/atoms/Carousels/Carousels';
import InfoPopoverComponent from 'libs/elements/shared-components/src/lib/molecules/InfoPopoverComponent/InfoPopoverComponent';
import React, { useState } from 'react';

interface ImageConfig {
  id: string;
  imgPath: string;
  label?: string;
  description?: string;
}

export type GetInfoRenderProps = ImageConfig[];

// This function returns the component factory
export const getInfoRenderComponent = (
  images: GetInfoRenderProps,
  placement: 'top' | 'bottom' | 'left' | 'right' = 'top',
  width: number = 200
) => {
  const renderItem = (item: CarouselItem, index: number) => {
    const [isLoading, setIsLoading] = useState(true);
    return (
      <div className="rounded-md p-2 w-full h-full">
        {isLoading && <LoadingSpinner extraClasses='absolute w-full h-full top-0 left-0' size="sm" />}
        <img
          width={width}
          height={width}
          loading='lazy'
          src={item.imgPath}
          alt={item.label || `Image ${index}`}
          onLoad={() => setIsLoading(false)}
          className="h-full w-full rounded-md object-cover"
        />
      </div>
    );
  };

  // Return a function that renders the component
  return () => (
    <InfoPopoverComponent placement={placement} width={width}>
      <Carousels
        items={images}
        width={width}
        itemsPerView={1}
        showLabels={false}
        autoPlay={true}
        autoPlayInterval={5000}
        gap={16}
        renderItem={renderItem}
      />
    </InfoPopoverComponent>
  );
};
